module.exports = {
	"data": {
		"postBySlug": {
			"html": "<p><font color=\"green\"><H1>Operating model: governance calendar</h1></font></p>\n<h3 id=\"as-a-public-company-dmgt-is-required-to-have-a-formal-board-and-governance-procedures-in-place-to-protect-that-status-the-board-delegates-certain-responsibilities-to-its-committees-which-meet-regularly-in-addition-to-these-formal-meetings-an-operating-rhythm-of-regular-interactions-between-dmgt-and-operating-company-management-has-been-established-to-streamline-the-approval-process-and-ensure-that-business-critical-deadlines-are-met\"><a href=\"#as-a-public-company-dmgt-is-required-to-have-a-formal-board-and-governance-procedures-in-place-to-protect-that-status-the-board-delegates-certain-responsibilities-to-its-committees-which-meet-regularly-in-addition-to-these-formal-meetings-an-operating-rhythm-of-regular-interactions-between-dmgt-and-operating-company-management-has-been-established-to-streamline-the-approval-process-and-ensure-that-business-critical-deadlines-are-met\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>As a public company DMGT is required to have a formal Board and governance procedures in place to protect that status. The Board delegates certain responsibilities to its Committees which meet regularly. In addition to these formal meetings, an operating rhythm of regular interactions between DMGT and Operating Company management has been established to streamline the approval process and ensure that business critical deadlines are met.</h3>\n<p><font color=\"green\"><H2>Key interactions with DMGT</h2></font></p>\n<h4 id=\"dmgt-board-and-committees\"><a href=\"#dmgt-board-and-committees\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>DMGT Board and Committees:</h4>\n<ul>\n<li>Papers reviewed two weeks prior to the meeting.</li>\n<li>Papers distributed to Committee members one week prior to the meeting.</li>\n</ul>\n<p>Items for which papers are not delivered within these timeframes may be taken off the relevant agenda.</p>\n<h4 id=\"disclosure-committee\"><a href=\"#disclosure-committee\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Disclosure Committee:</h4>\n<ul>\n<li>CFOs of Operating Companies to attend as invited to sign-off results relating to their business prior to publication of DMGT trading updates.</li>\n</ul>\n<h4 id=\"operating-rhythm\"><a href=\"#operating-rhythm\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Operating Rhythm:</h4>\n<ul>\n<li>Approvals and Executive Committee meetings held weekly (as needed).</li>\n<li>CEO 1:1 catch ups with Operating Company CEOs – monthly. </li>\n<li>CFO 1:1 catch ups with Operating Company CFO – monthly.</li>\n<li>Financial performance updates – monthly to quarterly. </li>\n<li>Operating updates – monthly to quarterly.</li>\n</ul>\n<hr>\n<p><font color=\"green\"><H2>Key dates in FY2018</h2></font></p>\n<p></p>\n<hr>\n<h4 id=\"contact\"><a href=\"#contact\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Contact:</h4>\n<p>Fran Sallas, Company Secretary (<a href=\"mailto:fran.sallas@dmgt.com\">fran.sallas@dmgt.com</a>)</p>",
			"timeToRead": 1,
			"excerpt": "Operating model: governance calendar As a public company DMGT is required to have a formal Board and governance procedures in place to...",
			"frontmatter": {
				"title": "Lesson Five",
				"cover": null,
				"date": null,
				"category": null,
				"tags": null
			}
		},
		"tableOfContents": {
			"chapters": [
				{
					"title": "1. Main Chapter",
					"entries": null,
					"chapters": [
						{
							"title": "1.1 Subchapter",
							"entries": [
								{
									"entry": {
										"id": "/opt/build/repo/content/lessons/lesson_one.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/1-dmgt-at-a-glance"
											},
											"frontmatter": {
												"title": "1. DMGT at a glance "
											}
										}
									}
								}
							],
							"chapters": [
								{
									"title": "1.1.1 Sub-subchapter",
									"entries": [
										{
											"entry": {
												"id": "/opt/build/repo/content/lessons/lesson_two.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/lesson-two-scope-and-responsibilities"
													},
													"frontmatter": {
														"title": "Lesson Two - Scope and responsibilities"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/opt/build/repo/content/lessons/lesson_three.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/lesson-three-code-of-conduct"
													},
													"frontmatter": {
														"title": "Lesson Three - Code of Conduct"
													}
												}
											}
										}
									]
								}
							]
						},
						{
							"title": "1.2 Subchapter",
							"entries": [
								{
									"entry": {
										"id": "/opt/build/repo/content/lessons/lesson_four.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/lesson-four"
											},
											"frontmatter": {
												"title": "Lesson Four"
											}
										}
									}
								}
							],
							"chapters": null
						}
					]
				},
				{
					"title": "2. Main Chapter",
					"entries": null,
					"chapters": [
						{
							"title": "2.1 Subchapter",
							"entries": [
								{
									"entry": {
										"id": "/opt/build/repo/content/lessons/lesson_five.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/lesson-five"
											},
											"frontmatter": {
												"title": "Lesson Five"
											}
										}
									}
								}
							],
							"chapters": null
						}
					]
				},
				{
					"title": "3. Main Chapter",
					"entries": [
						{
							"entry": {
								"id": "/opt/build/repo/content/lessons/lesson_six.md absPath of file",
								"childMarkdownRemark": {
									"fields": {
										"slug": "/lesson-six"
									},
									"frontmatter": {
										"title": "Lesson Six"
									}
								}
							}
						}
					],
					"chapters": null
				}
			]
		}
	},
	"pathContext": {
		"slug": "/lesson-five"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/lesson-five.json
// module id = 405
// module chunks = 94184770335722